module.exports = __webpack_public_path__ + "media/images/number_8_green-749e7ecae495710dc854baec80d95da1.png";